import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Formik, Field, useFormikContext } from 'formik'
import { Form, Row, Col, Button, Select, Card } from 'antd'
import TextField from '../../../shared/TextField'
import { wombaOptions } from '../../../../data/selectOptions'
import { organizationsSchema } from '../../../../schema/organizations'

const FormikStateSpy = ({ onDirtyChange }) => {
  const { dirty } = useFormikContext()

  useEffect(() => {
    if (onDirtyChange) {
      onDirtyChange(dirty)
    }
  }, [dirty, onDirtyChange])

  return null
}

const OrganizationForm = ({
  initialValues,
  onSubmit,
  isSubmitAllowed,
  innerRef,
  onDirtyChange,
}) => {
  const selectOptions = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ]

  const handleWombaChange = (wombaOption, values, setValues) => {
    const isRetrieverDisabled =
      wombaOption !== 'ON' && wombaOption !== 'SERVICE TYPE ONLY'

    setValues(
      {
        ...values,
        isRetrieverDisabled,
        retriever_cms_id: isRetrieverDisabled ? '' : values.retriever_cms_id,
        womba: wombaOption,
      },
      true
    )
  }

  const isInitiallyDisabled =
    initialValues?.womba !== 'ON' && initialValues?.womba !== 'SERVICE TYPE ONLY'

  const formInitialValues = {
    ...initialValues,
    isRetrieverDisabled: isInitiallyDisabled,
    retriever_cms_id: initialValues?.retriever?.cms_id || '',
  }

  return (
    <Card className="user-info-card" style={{ marginTop: '10px' }}>
      <Formik
        innerRef={innerRef}
        initialValues={formInitialValues}
        validationSchema={organizationsSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ handleSubmit, values, setValues, dirty }) => (
          <Form onFinish={handleSubmit} className="user-form" layout="vertical">
            <FormikStateSpy onDirtyChange={onDirtyChange} />

            <Row justify="space-between">
              <Col>
                <Form.Item>
                  <div className="user-form__title">
                    {initialValues?.name || 'Assignments'}
                  </div>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col span={12}>
                <Form.Item label="Womba">
                  <Select
                    value={values.womba}
                    name="womba"
                    options={wombaOptions}
                    onChange={wombaOption => {
                      handleWombaChange(wombaOption, values, setValues)
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Field
                  component={TextField}
                  label="Retriever CMS ID"
                  name="retriever_cms_id"
                  disabled={values.isRetrieverDisabled}
                />
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <Field
                  component={TextField}
                  label="APS CMS Supervisor ID"
                  name="cms_aps_supervisor_id"
                />
              </Col>
              <Col span={12}>
                <Field
                  component={TextField}
                  label="ODR CMS Supervisor ID"
                  name="cms_odr_supervisor_id"
                />
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item label="Dump Screen Enabled">
                  <Select
                    value={values.is_active_dump_screen}
                    name="is_active_dump_screen"
                    options={selectOptions}
                    onChange={value => {
                      setValues({ ...values, is_active_dump_screen: value })
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>

            {isSubmitAllowed && (
              <Button
                type="primary"
                ghost
                htmlType="submit"
                disabled={!dirty}
                style={{ marginTop: '8px' }}
              >
                Save Changes
              </Button>
            )}
          </Form>
        )}
      </Formik>
    </Card>
  )
}

OrganizationForm.propTypes = {
  initialValues: PropTypes.shape({
    name: PropTypes.string,
    womba: PropTypes.string,
    retriever_cms_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    cms_aps_supervisor_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    cms_odr_supervisor_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    is_active_dump_screen: PropTypes.bool,
    retriever: PropTypes.shape({
      cms_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  }),
  onSubmit: PropTypes.func.isRequired,
  isSubmitAllowed: PropTypes.bool,
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  onDirtyChange: PropTypes.func,
}

OrganizationForm.defaultProps = {
  initialValues: {},
  isSubmitAllowed: true,
  innerRef: null,
  onDirtyChange: () => {},
}

export default OrganizationForm
